export default "__VITE_ASSET__BNTVPica__"